import { render, staticRenderFns } from "./PCAssetOverview.vue?vue&type=template&id=98ac62ae&scoped=true"
import script from "./PCAssetOverview.vue?vue&type=script&lang=js"
export * from "./PCAssetOverview.vue?vue&type=script&lang=js"
import style0 from "./PCAssetOverview.vue?vue&type=style&index=0&id=98ac62ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98ac62ae",
  null
  
)

export default component.exports